import router from '../../router'
import axios from 'axios'
import {
  redirectInvalidUser,
  getMobSessid
} from '../../functions'
import messages from '../../constants'
import { Order } from '../../entity/Order'

export default {
  namespaced: true,
  state: {
    list: null,
    limit: 10,
    page: 1,
    quantityPage: 0,
    currentPage: 1,
    error: null,
    loading: true,
    status: 'opened', // opened || closed
    showPagination: false,
    pagination: {}
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    setOrders (state, order) {
      state.list = order
    },
    setError (state, error) {
      state.error = error
    },
    nextPage (state) {
      state.page++
      state.currentPage++
    },
    prevPage (state) {
      if (state.page >= 1) {
        state.page--
        state.currentPage--
      }
    },
    page (state, page) {
      state.page = page
    },
    setStatus (state, value) {
      state.status = value
    },
    setShowPagination (state, value) {
      state.showPagination = value
    },
    setPagination (state, value) {
      state.pagination = value
    }
  },
  actions: {
    loadOrders (context) {
      context.commit('setOrders', [])
      context.commit('setLoading', true)
      context.commit('setError', null)
      context.commit('setShowPagination', false)
      context.commit('setPagination', {})

      const mobsessid = getMobSessid()

      if (mobsessid == null) {
        redirectInvalidUser()
        return
      }

      let url = process.env.VUE_APP_CUSTOMER_PANEL_API_URL
      url += process.env.VUE_APP_MOS_ORDERS
      url += mobsessid

      const response = axios.get(url, {
        params: {
          page: context.state.page,
          status: context.state.status,
          limit: context.state.limit
        }
      })

      let messageError = messages.NO_ORDERS
      switch (context.state.status) {
        case 'opened':
          messageError = { open: messages.NO_ORDERS_OPENED }
          break
        case 'closed':
          messageError = messages.NO_ORDERS_CLOSED
          break
      }

      response
        .then(response => response.data)
        .then(data => {
          if (data.code === 400 || data.code === 404) {
            throw { data: messageError }
          }

          if (data.code === 401) {
            redirectInvalidUser()
            return
          }

          if (data.code === 500 || data.code === 504) {
            throw { data: messages.ERROR_AWAIT }
          }

          const ordersData = data.orders
          context.dispatch('formatPagination', data.page)

          if (Array.isArray(ordersData)) {
            const orders = ordersData.map(element =>
              new Order(element)
            )

            if (orders.length > 0) {
              context.commit('setOrders', orders)
            } else {
              context.commit('setOrders', [])
              throw { data: messageError }
            }
          }

          context.commit('setLoading', false)
        }).catch(error => {
          let errorMessage = messageError
          if (error !== undefined && error.data != null) {
            errorMessage = error.data
          }
          context.commit('setError', errorMessage)
          context.commit('setLoading', false)
        })
    },
    changeStatusOrder (context, value) {
      context.commit('page', 1)
      context.commit('setStatus', value)
      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status
        }
      }).catch(() => {})
      context.dispatch('loadOrders')
    },
    loadNextPage (context) {
      if (context.state.pagination.page >= context.state.pagination.pages) {
        return
      }

      context.commit('nextPage')

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status
        }
      }).catch(() => {})

      context.dispatch('loadOrders')
    },
    loadPrevPage (context) {
      if (context.state.pagination.page == 1) {
        return
      }

      context.commit('prevPage')

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status
        }
      }).catch(() => {})

      context.dispatch('loadOrders')
    },
    setPage (context, value) {
      context.commit('page', value != null ? value : 1)

      router.push({
        name: 'orders',
        query: {
          page: context.state.page,
          filter: context.state.status
        }
      }).catch(() => {})

      context.dispatch('loadOrders')
    },
    changeStatus (context, value) {
      context.commit('setStatus', value != null ? value : context.state.status)
    },
    setLoading (context, value) {
      context.commit('setLoading', value)
    },
    formatPagination (context, value) {
      if (value.pages > 1) {
        context.commit('setShowPagination', true)

        const current = value.page
        const last = value.pages
        const delta = 2
        const left = current - delta
        const right = current + delta + 1
        const range = []
        const rangeWithDots = []
        let keyRange

        for (let i = 1; i <= last; i++) {
          if (i == 1 || i == last || i >= left && i < right) {
            range.push(i)
          }
        }

        for (const i of range) {
          if (keyRange) {
            if (i - keyRange === 2) {
              rangeWithDots.push(keyRange + 1)
            } else if (i - keyRange !== 1) {
              // rangeWithDots.push('...');
            }
          }
          rangeWithDots.push(i)
          keyRange = i
        }
        value.listPage = rangeWithDots
        context.commit('setPagination', value)
      }
    }
  },
  getters: {
    getPage: state => {
      return state.page
    }
  }
}
